import api from './ajax.js';

document.addEventListener("DOMContentLoaded", function () {
	const selectClient = document.getElementById("selectClient");
	const selectFarm = document.getElementById("selectFarm");

	// Fix: Set the selected farm from data attribute (browser may reset the selected attribute)
	if (selectFarm) {
		const selectedFarmId = selectFarm.dataset.selectedFarmId;
		if (selectedFarmId) {
			selectFarm.value = selectedFarmId;
		}
	}

	if (!selectClient) return;

	// Get the jobId from data attr on the select element
	const jobId = selectClient.dataset.spJobId;

	// Get the initial value of the select element
	const initialClientId = selectClient.value;

	// On page load, populate client info
	if (initialClientId) {
		populateClientFields(initialClientId);
	}

	selectClient.addEventListener("change", function () {
		const clientId = this.value;

		// If no client is selected, clear the fields and return
		if (!clientId) {
			clearClientFields();
			clearFarmDropdown();
			return;
		}

		// When client changes, update client and clear farm selection
		setClientOnJob(jobId, clientId);
		loadFarmsForClient(clientId);
		// Reset farm dropdown
		if (selectFarm) {
			selectFarm.value = "";
		}
	});

	// Handle farm selection change
	if (selectFarm) {
		// On page load, set readonly state based on current selection
		const initialFarmId = selectFarm.value;
		if (initialFarmId && initialFarmId !== 'new') {
			setJobAddressFieldsReadonly(true);
			// Load and populate farm address (also handles reference image)
			populateFarmAddress(initialFarmId);
		} else {
			// No farm selected on load - show upload input
			showReferenceImageUpload();
		}

		selectFarm.addEventListener("change", function () {
			const farmId = this.value;

			if (farmId === 'new') {
				// New farm selected - clear and enable fields
				clearJobAddressFields();
				setJobAddressFieldsReadonly(false);
				showNewFarmNameInput(true);
				showReferenceImageUpload();
			} else if (farmId) {
				// Existing farm selected - populate and make readonly
				populateFarmAddress(farmId);
				setJobAddressFieldsReadonly(true);
				showNewFarmNameInput(false);
				addFarmToJob(jobId, farmId);
				// Reference image is handled in populateFarmAddress
			} else {
				// No farm selected - clear farm association and enable fields
				clearJobAddressFields();
				setJobAddressFieldsReadonly(false);
				showNewFarmNameInput(false);
				showReferenceImageUpload();
				// Clear farm association on job
				clearFarmFromJob(jobId);
			}
		});
	}

	// Populate client fields only (on page load)
	function populateClientFields(clientId) {
		api.addClientToJob(jobId, clientId).then(response => {
			if (!response.error) {
				const client = response.body.client;
				document.getElementById("clientCompanyTradingName").value = client.company_trading_name || "";
				document.getElementById("clientCompanyABN").value = client.abn || "";
				document.getElementById("firstName").value = client.first_name || "";
				document.getElementById("clientLastName").value = client.last_name || "";
				document.getElementById("clientEmail").value = client.email || "";
				document.getElementById("clientPhone").value = client.phone || "";
				// Client postal address fields (from nested address object)
				const address = client.address || {};
				document.getElementById("clientAddress").value = address.address_line_1 || "";
				document.getElementById("clientCity").value = address.city || "";
				document.getElementById("clientState").value = address.state || "";
				document.getElementById("clientPostcode").value = address.postcode || "";
			}
		});
	}

	// Set client on job and populate fields (when client changes)
	function setClientOnJob(jobId, clientId) {
		api.addClientToJob(jobId, clientId).then(response => {
			if (response.error) {
				alert('An error occurred');
			} else {
				const client = response.body.client;
				document.getElementById("clientCompanyTradingName").value = client.company_trading_name || "";
				document.getElementById("clientCompanyABN").value = client.abn || "";
				document.getElementById("firstName").value = client.first_name || "";
				document.getElementById("clientLastName").value = client.last_name || "";
				document.getElementById("clientEmail").value = client.email || "";
				document.getElementById("clientPhone").value = client.phone || "";
				// Client postal address fields (from nested address object)
				const address = client.address || {};
				document.getElementById("clientAddress").value = address.address_line_1 || "";
				document.getElementById("clientCity").value = address.city || "";
				document.getElementById("clientState").value = address.state || "";
				document.getElementById("clientPostcode").value = address.postcode || "";
			}
		});
	}

	// Helper function to clear all client fields
	function clearClientFields() {
		const fields = [
			"clientCompanyTradingName",
			"clientCompanyABN",
			"firstName",
			"clientLastName",
			"clientEmail",
			"clientPhone",
			"clientAddress",
			"clientCity",
			"clientState",
			"clientPostcode",
		];
		fields.forEach((fieldId) => {
			const field = document.getElementById(fieldId);
			if (field) field.value = "";
		});
	}

	// Helper function to clear farm dropdown
	function clearFarmDropdown() {
		const selectFarm = document.getElementById("selectFarm");
		if (selectFarm) {
			selectFarm.innerHTML = '<option value="">Please Select Farm</option>';
		}
	}

	// Load farms for a specific client
	function loadFarmsForClient(clientId) {
		api.getFarmsForClient(clientId).then(response => {
			if (response.error) return;

			const farms = response.body.farms;
			const selectFarm = document.getElementById("selectFarm");

			if (!selectFarm) return;

			// Clear existing options
			selectFarm.innerHTML = '<option value="">Please Select Farm</option>';

			// Add farm options
			farms.forEach(farm => {
				const option = document.createElement('option');
				option.value = farm.id;
				option.textContent = farm.farm_name;
				selectFarm.appendChild(option);
			});

			// Add "+ New Farm" option
			const newFarmOption = document.createElement('option');
			newFarmOption.value = 'new';
			newFarmOption.textContent = '+ New Farm';
			selectFarm.appendChild(newFarmOption);

			// Clear address fields and enable them (no farm selected yet)
			clearJobAddressFields();
			setJobAddressFieldsReadonly(false);
			showNewFarmNameInput(false);
			showReferenceImageUpload();
		});
	}

	// Add farm to job (just saves the association, no field population needed)
	function addFarmToJob(jobId, farmId) {
		api.addFarmToJob(jobId, farmId);
	}

	// Clear farm from job
	function clearFarmFromJob(jobId) {
		api.addFarmToJob(jobId, null);
	}

	// Populate job address fields from farm data
	function populateFarmAddress(farmId) {
		api.getFarm(farmId).then(response => {
			if (response.error) return;

			const farm = response.body;
			const addressField = document.querySelector('[data-sp-address="job-street"] input');
			const cityField = document.querySelector('[data-sp-address="job-city"] input');
			const stateField = document.querySelector('[data-sp-address="job-state"] select, [data-sp-address="job-state"] input');
			const postcodeField = document.querySelector('[data-sp-address="job-postcode"] input');

			if (addressField) addressField.value = farm.address_line_1 || '';
			if (cityField) cityField.value = farm.city || '';
			if (stateField) stateField.value = farm.state || '';
			if (postcodeField) postcodeField.value = farm.postcode || '';

			// Handle reference image display
			showFarmReferenceImage(farm.reference_image);
		});
	}

	// Set job address fields readonly or editable
	function setJobAddressFieldsReadonly(readonly) {
		const fields = [
			document.querySelector('[data-sp-address="job-street"] input'),
			document.querySelector('[data-sp-address="job-city"] input'),
			document.querySelector('[data-sp-address="job-state"] select, [data-sp-address="job-state"] input'),
			document.querySelector('[data-sp-address="job-postcode"] input')
		];

		fields.forEach(field => {
			if (field) {
				field.readOnly = readonly;
				if (field.tagName === 'SELECT') {
					field.disabled = readonly;
				}
				// Visual indicator
				if (readonly) {
					field.classList.add('form__control--readonly');
				} else {
					field.classList.remove('form__control--readonly');
				}
			}
		});
	}

	// Clear job address fields
	function clearJobAddressFields() {
		const addressField = document.querySelector('[data-sp-address="job-street"] input');
		const cityField = document.querySelector('[data-sp-address="job-city"] input');
		const stateField = document.querySelector('[data-sp-address="job-state"] select, [data-sp-address="job-state"] input');
		const postcodeField = document.querySelector('[data-sp-address="job-postcode"] input');

		if (addressField) addressField.value = '';
		if (cityField) cityField.value = '';
		if (stateField) stateField.value = '';
		if (postcodeField) postcodeField.value = '';
	}

	// Show/hide new farm name input
	function showNewFarmNameInput(show) {
		let container = document.getElementById('newFarmNameContainer');

		if (show && !container) {
			// Create the new farm name input container
			const selectFarm = document.getElementById('selectFarm');
			container = document.createElement('div');
			container.id = 'newFarmNameContainer';
			container.className = 'mt-3';
			container.innerHTML = `
				<label for="newFarmNameInput">New Farm Name</label>
				<input type="text" class="form__control" id="newFarmNameInput" name="new_farm_name" placeholder="Enter farm name" required>
			`;
			selectFarm.parentNode.appendChild(container);
		} else if (!show && container) {
			container.remove();
		}
	}

	// Show farm reference image (for existing farms) or file upload (for new farms)
	function showFarmReferenceImage(imageUrl) {
		const uploadEl = document.getElementById('referenceImageUpload');
		const previewEl = document.getElementById('farmReferenceImagePreview');
		const noImageEl = document.getElementById('farmNoReferenceImage');
		const existingJobImage = document.getElementById('existingJobImage');

		// Hide existing job image when showing farm image
		if (existingJobImage) {
			existingJobImage.classList.add('d-none');
		}

		if (imageUrl) {
			// Show farm image preview
			if (uploadEl) uploadEl.classList.add('d-none');
			if (noImageEl) noImageEl.classList.add('d-none');
			if (previewEl) {
				previewEl.classList.remove('d-none');
				const img = document.getElementById('farmReferenceImage');
				const link = document.getElementById('farmReferenceImageLink');
				if (img) img.src = imageUrl;
				if (link) link.dataset.spImage = imageUrl;
			}
		} else {
			// No image for this farm
			if (uploadEl) uploadEl.classList.add('d-none');
			if (previewEl) previewEl.classList.add('d-none');
			if (noImageEl) noImageEl.classList.remove('d-none');
		}
	}

	// Show file upload input (for new farms or no farm selected)
	function showReferenceImageUpload() {
		const uploadEl = document.getElementById('referenceImageUpload');
		const previewEl = document.getElementById('farmReferenceImagePreview');
		const noImageEl = document.getElementById('farmNoReferenceImage');
		const existingJobImage = document.getElementById('existingJobImage');

		if (uploadEl) uploadEl.classList.remove('d-none');
		if (previewEl) previewEl.classList.add('d-none');
		if (noImageEl) noImageEl.classList.add('d-none');
		// Show existing job image if present (for new farm case)
		if (existingJobImage) {
			existingJobImage.classList.remove('d-none');
		}
	}
});
